import { MemoizedOwnGoogleMap } from './googleMaps/GoogleMaps';
import SocialIcon from './SocialMediaIcons';
import { previewScrollbar } from 'shared-widget-components/src/components/preview/previewScrollbar';
import { useTranslation } from 'react-i18next';
import { ContactWidgetState } from '../models/ContactWidgetState';
import { ContactInfo } from './widget/ContactInfo';

// Kapcsolat widget previewnézete
export const ContactComponent = (props: ContactWidgetState) => {
  //@ts-ignore
  const languageCode = window.currentLanguageCode;

  const { t } = useTranslation();
  const getLanguageContent = () => {
    if (props.widgetTitle && props.widgetTitle[languageCode]) {
      const languageConent = props.widgetTitle[languageCode];
      return languageConent;
    }
    if (props.widgetTitle) return props.widgetTitle['hu'];
    return { title: '' };
  };
  return (
    <div
      className='flex justify-center relative min-[350px]:items-start sm:items-center mx-auto w-full previewScrollbar h-full min-[350px]:overflow-y-auto sm:overflow-hidden min-[350px]:py-4 sm:py-6 lg:py-10'
      style={{ background: props.backgroundColor }}
    >
      <style>{previewScrollbar}</style>
      <div className='max-w-[1240px] md:flex justify-center w-full items-center px-2'>
        <div className={`min-[350px]:w-full md:w-[45%] lg:w-[35%] h-fit bg-transparent  min-[350px]:pb-5 md:pb-0 lg:pb-5 z-2 relative px-3   lg:mr-1`}>
          <h1 className='font-body font-bold min-[350px]:text-[26px] sm:text-[28px] mb-2 min-h-[30px] min-[350px]:pb-0 sm:pb-5 md:pb-3 lg:pb-5' style={{ color: props.textColor }}>
            {getLanguageContent().title}
          </h1>
          <ContactInfo props={props} />
          <div className='mt-3 '>
            <h1 className={`font-body min-[350px]:text-[16px] text-black sm:text-[18px]  font-bold`} style={{ color: props.textColor }}>
              {t('contact.followUs')}
            </h1>
            <div className='flex gap-2'>{props.socialMedia && props.socialMedia.map((social, index) => <SocialIcon key={index} icon={social.icon} link={social.link} iconColor={props.iconColor} />)}</div>
          </div>
        </div>
        <div className='min-[350px]:w-full md:w-[55%] lg:w-[65%] flex justify-center items-center min-[350px]:px-3 min-[350px]:pl-0 sm:pl-4 md:pl-0 lg:pl-4 sm:px-0  mb-0'>
          <MemoizedOwnGoogleMap lat={props.lat} lng={props.lng} />
        </div>
      </div>
    </div>
  );
};
